export default from './Slider'
